import AboutContainer from './about-container';

export default AboutContainer;
